import { IQualifier, Qualifier } from './qualifier';

export class DispatchPoint {

    constructor(dispatchPoint: IDispatchPoint) {

        this.gisFeatureId = dispatchPoint.gisFeatureId;
        this.commonName = dispatchPoint.commonName;
        this.qualifier = new Qualifier(dispatchPoint.qualifier);
        this.controlPointNumber = dispatchPoint.controlPointNumber;
        this.deviceNumber = dispatchPoint.deviceNumber;
        this.segmentNumber = dispatchPoint.segmentNumber;
    }
    
    gisFeatureId: number;
    commonName: string;
    qualifier: Qualifier;
    controlPointNumber: string;
    deviceNumber: string;
    segmentNumber: string;
}

export interface IDispatchPoint {

    gisFeatureId: number;
    commonName: string;
    qualifier: IQualifier;
    controlPointNumber: string;
    deviceNumber: string;
    segmentNumber: string;
}